import { Routes } from '@angular/router';
import { authGuard } from './core/services/auth-guard.service';
import { NgForm } from '@angular/forms';

export default [
  {
    path: '',
    loadComponent: () => import('./layout/components/app.layout.custom').then((c) => c.AppLayoutCustom),
    children: [
      { path: '', redirectTo: '/p360', pathMatch: 'full' },
      {
        path: 'p360',
        loadChildren: () => import('./pages/pages.routes'),
        canActivate: [authGuard],
      },
    ],
    providers: [NgForm],
  },
  {
    path: '',
    loadChildren: () => import('./pages/security/security.routes'),
    canActivateChild: [authGuard],
  },
  { path: '**', redirectTo: '/p360/404' },
] as Routes;
